import script from "./AppSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwitch.vue?vue&type=script&setup=true&lang=js"

import "./AppSwitch.vue?vue&type=style&index=0&id=20bb52e8&lang=css"

const __exports__ = script;

export default __exports__